import React from 'react';
import PropTypes from 'prop-types';

import EmptyState from 'components/project/empty_state';
import LeadsFunnel from 'components/project/leads_funnel';
import LeadsTable from '../leads_table';
import Card from './card';

export default class Leads extends React.Component {
  static propTypes = {
    card: PropTypes.shape({
      id: PropTypes.number.isRequired
    }),
    editable: PropTypes.bool,
    fullScreen: PropTypes.bool,
    hideLastActivity: PropTypes.bool,
    leads: PropTypes.array.isRequired,
    leadStatuses: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    savedNoteForLeadId: PropTypes.number,
    onSetAsActive: PropTypes.func,
    onUpdateNote: PropTypes.func,
    onVisibilityChanged: PropTypes.func
  }

  renderPreview() {
    return (
      <LeadsFunnel
        leads={this.props.leads}
        leadStatuses={this.props.leadStatuses}
        limit={7}
        name="leadsFunnel"
      />
    );
  }

  renderFullscreen() {
    const { editable, leads, leadStatuses, savedNoteForLeadId, onUpdateNote, hideLastActivity } = this.props;

    return (
      <div className="lead-details">
        <div className="details w-100">
          <LeadsTable
            editable={editable}
            hideLastActivity={hideLastActivity}
            leads={leads}
            leadStatuses={leadStatuses}
            savedNoteForLeadId={savedNoteForLeadId}
            onUpdateNote={onUpdateNote}
          />
        </div>
      </div>
    );
  }

  renderBody() {
    if (this.props.leads.length === 0) {
      return <EmptyState imageSrc="/images/project_empty_states/leads.svg" message="No Leads to display." />;
    }

    return this.props.fullScreen ? this.renderFullscreen() : this.renderPreview();
  }

  render() {
    const { onSetAsActive, ...passThroughProps } = this.props;

    return (
      <Card
        {...passThroughProps}
        subtitle="Overview of Leads for this listing"
        title="Leads"
        onSetAsActive={this.props.leads.length === 0 ? null : onSetAsActive}
      >
        {this.renderBody()}
      </Card>
    );
  }
}
